<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="加工组织">
              <global-select
                :value.sync="queryParams.organizationCode"
                selectType="selectAssembleMultiple"
                requestApi="/system/user/inventOrgList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :dropdown-match-select-width="false"
                :assembleLabel="true"
                @change="organizationCodeChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工序编码">
              <a-select v-model="queryParams.operationCode" mode="multiple" :max-tag-text-length="2" :max-tag-count="1" @change="operationCodeOnChange">
                <a-select-option v-for="(item) in operationCodeList" :key="item.label">{{ item.realValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParams.operationStatus" allowClear>
                <a-select-option v-for="(item) in statusOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiBomOperationNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['bom:bomOperation:add']">新建</a-button>
      <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['bom:bomOperation:import']">导入</a-button>
      <a-button @click="handleExport" v-hasPermi="['bom:bomOperation:export']">导出</a-button>
      <a-button @click="importTemplate" v-hasPermi="['bom:bomOperation:template']">下载模板</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <!-- <a-table
          ref="table"
          :columns="columns"
          :loading="pageParams.tableLoading"
          :data-source="typeList"
          row-key="id"
          :pagination="false"
          :scroll="{ x: 1300}"
        >
          <span slot="operationCodeTitle">
            <i class="toRequired">*</i>工序编码
          </span>
          <template slot="operationCode" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ record.operationCode }}</span>
            <a-input v-if="isEdit && currentId === record.id" v-model="record.operationCode" size="small" />
          </template>
          <template slot="operationDesc" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ record.operationDesc }}</span>
            <a-input v-if="isEdit && currentId === record.id" v-model="record.operationDesc" size="small" />
          </template>
          <template slot="operationStatus" slot-scope="text, record">
            <a-switch v-if="!isEdit || currentId !== record.id" disabled :checked="record.operationStatus === 'Y'" />
            <a-popconfirm
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirmHandleStatus(record)"
              @cancel="cancelHandleStatus(record)"
            >
              <span slot="title">请确认是否更改状态</span>
              <a-switch v-if="isEdit && currentId === record.id" :checked="record.operationStatus === 'Y'" />
            </a-popconfirm>
          </template>
          <template slot="updateTime" slot-scope="text">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <template slot="createTime" slot-scope="text">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <span slot="operation" slot-scope="text, record">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['bom:bomOperation:edit']">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </a-table> -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.PRODUCTION_PROCESSES_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="operationCode" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.operationCode }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.operationCode" size="small" />
          </template>
          <template slot="operationDesc" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.operationDesc }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.operationDesc" size="small" />
          </template>
          <template slot="capacity" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.capacity }}</span>
            <a-input-number :min="0" v-if="isEdit && currentId === text.record.id" v-model="text.record.capacity" size="small" />
          </template>
          <template slot="operationStatus" slot-scope="text">
            <a-switch v-if="!isEdit || currentId !== text.record.id" disabled :checked="text.record.operationStatus === 'Y'" />
            <a-popconfirm
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirmHandleStatus(text.record)"
              @cancel="cancelHandleStatus(text.record)"
            >
              <span slot="title">请确认是否更改状态</span>
              <a-switch v-if="isEdit && currentId === text.record.id" :checked="text.record.operationStatus === 'Y'" />
            </a-popconfirm>
          </template>
          <template slot="updateTime" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <template slot="createTime" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)" v-hasPermi="['bom:bomOperation:edit']">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
        <!-- 底部分页按钮 -->
        <!-- <Page ref="page" :pageParams.sync="pageParams" @getList="getList" /> -->
        <production-processes-add
          ref="createModal"
          @handle-success="handleOk"
        />
      </div>
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @ok="importExcelHandleCancel"
        @cancel="importExcelHandleCancel"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiBomOperationUpdate, apiBomOperationFindList, apiBomOperationList, apiBomOperationNewExport } from '@/api/mes/basedata/productionProcesses'
import ProductionProcessesAdd from './components/production-processes-add'
import Cookies from 'js-cookie';
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  name: 'ProductionProcesses',
  components: {
    DownloadModal,
    ProductionProcessesAdd
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
        apiBomOperationNewExport,
        // 表格配置
        tableProps: {
        requestApi: generateLsTableResData(apiBomOperationList, true),
        pageCurrent: true
      },
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/bom/bomOperation/import'
      },
      isEdit: false,
      currentId: "",
      pageParams: {
        automatic: true,
        pageUrl: '/bom/bomOperation/list',
        tableLoading: false
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        operationCode: undefined,
        operationStatus: undefined
      },
      // 状态快码
      statusOptions: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      // 快码表格数据
      typeList: [],
      // 表格字段
      columns: [
        {
          title: '加工组织',
          dataIndex: 'organizationName',
          align: 'center'
        },
        {
          title: '工序编码',
          dataIndex: 'operationCode',
          align: 'center'
        },
        {
          title: '工序说明',
          dataIndex: 'operationDesc',
          scopedSlots: { customRender: 'operationDesc' },
          ellipsis: true,
          align: 'center',
          type: "input"
        },
        {
          title: '日产能',
          dataIndex: 'capacity',
          scopedSlots: { customRender: 'capacity' },
          align: 'center'
        },
        // {
        //   title: '产能/时',
        //   dataIndex: 'unitCapacity',
        //   width: 120,
        //   scopedSlots: { customRender: 'unitCapacity' },
        //   align: 'center'
        // },
        {
          title: '状态',
          dataIndex: 'operationStatus',
          scopedSlots: { customRender: 'operationStatus' },
          align: 'center'
        },
        {
          title: '最后修改人',
          dataIndex: 'updateName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 160,
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      operationCodeList: [] // 工序编码
    }
  },
  created () {
    this.getOperationCodeList()
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    operationCodeOnChange (val) {},
    confirmHandleStatus (row) {
      row.operationStatus = row.operationStatus === 'Y' ? 'N' : 'Y'
    },
    cancelHandleStatus (row) {
    },
    organizationCodeChange () {
      this.getOperationCodeList()
    },
    // 工序编码
    getOperationCodeList () {
      apiBomOperationFindList({ organizationCode: this.queryParams.organizationCode }).then(res => {
        if (res.rows && res.rows.length > 0) {
          this.operationCodeList = res.rows
        } else {
          this.operationCodeList = []
        }
      })
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      // if (!record.unitCapacity || Number(record.unitCapacity) <= 0) {
      //   this.$message.warning('产能/时不能为空且需大于0')
      //   return
      // }
      apiBomOperationUpdate(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
          this.isEdit = false;
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.onSearch()
      this.isEdit = false;
    },
    /** 查询列表 */
    getList (data) {
      this.typeList = data
      this.isEdit = false
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        organizationCode: undefined,
        operationCode: undefined,
        operationStatus: undefined
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('bom/bomOperation/template', {
        ...this.queryParams
      }, `工序导入模板_${new Date().getTime()}.xlsx`)
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('bom/bomOperation/export', {
      //   ...this.queryParams
      // }, `工序_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
</style>
